import { render, staticRenderFns } from "./ServiceReviews.vue?vue&type=template&id=a2f34424&scoped=true&"
import script from "./ServiceReviews.vue?vue&type=script&lang=js&"
export * from "./ServiceReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f34424",
  null
  
)

export default component.exports